
import CloseIcon from '@mui/icons-material/Close';
import {
    Dialog, DialogContent, DialogTitle,
    IconButton,
    Tooltip
} from '@mui/material';

import SyntaxHighlighter from 'react-syntax-highlighter';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { DataContext } from '../../../contexts';

export const LinkDialog = ({ isOpen, handleClose }) => {

    const {
        ufficioId,
    } = useParams();

    const {
        impostazione
    } = useContext(DataContext);

    const [tooltipMessage, setTooltipMessage] = useState("Copia");

    const handleOnClose = () => {
        handleClose();
    }

    const link = `${impostazione?.publicLinkDomain ?? ''}?uffici=${ufficioId}`.replace(/ /g, '%20');

    return (
        <Dialog open={isOpen} maxWidth='sm' fullWidth>
            <IconButton
                aria-label="close"
                size="small"
                sx={{
                    position: "absolute",
                    top: 8,
                    right: 4,
                }}
                onClick={handleOnClose}>
                <CloseIcon />
            </IconButton>
            <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
                LINK PUBBLICO
            </DialogTitle>
            <DialogContent>
                <div
                    style={{
                        position: 'relative',
                    }}>
                    <SyntaxHighlighter language="html" id='linkRisultatoRicerca'>
                        {link}
                    </SyntaxHighlighter>
                    <Tooltip title={tooltipMessage} onClose={() => {
                        setTooltipMessage("Copia");
                    }}>
                        <IconButton sx={{
                            position: 'absolute',
                            top: '4px',
                            right: '4px'
                        }}

                            onClick={() => {
                                navigator.clipboard.writeText(link);
                                setTooltipMessage("Copiato nella clipboard!");

                            }}>
                            <ContentCopyIcon />
                        </IconButton>
                    </Tooltip>
                </div>
            </DialogContent>
        </Dialog>
    )
}